import React from "react";

export default function TeamMember({ name, email, image1, image2 = null, image3 = null, withPaddingBottom=false, withPaddingTop=true, children }) {
  return (
    <>
      <section className={`team-area-content pt-3 ${withPaddingBottom ? "pb-5" : ""} ${withPaddingTop ? "pt-5" : ""}`}>
        <div className="container">
          <div className="lower-content" style={withPaddingBottom ? {} : {borderBottom: "1px solid rgb(204,204,204)"}}>
            <div className="row d-flex justify-content-center">
              <div className="col-sm-12 col-lg-3 mb-2">
                <div className="team-img-box">
                  <img src={image1} alt="img" />
                </div>
                <div className="per-info">
                  <h4>{name}</h4>
                  {/* <ul>
                    <li>
                      <div className="icon">
                        <i className="icon fa-solid fa-envelope"></i>{" "}
                        <strong>Email</strong>
                      </div>
                      <div className="text">{email}</div>
                    </li>
                  </ul> */}
                </div>
              </div>
              <div className="text-column col-lg-4 col-sm-12">
                <div
                  className="s-about-content wow fadeInRight"
                  data-animation="fadeInRight"
                  data-delay=".2s"
                >
                  {children}
{/* 
                  <div className="two-column mt-30">
                    <div className="row">
                      <div className="image-column col-md-6">
                        {image2 && (
                          <figure className="image">
                            <img src={image2} alt="" />
                          </figure>
                        )}
                      </div>
                      <div className="text-column col-md-6">
                        {image3 && (
                          <figure className="image">
                            <img src={image3} alt="" />
                          </figure>
                        )}
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
